// extracted by mini-css-extract-plugin
export default {"addToCartControl":"XZ-z","giftCard":"YZ-z","btnContainer":"ZZ-z","cartButton":"_Z-z","disabled":"a0-z"};